import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { auth } from '../config/firebase';
import logo from '../Logo/AroundU.png'; // Updated logo import
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user && user.email === 'admin@aroundu.co.za') {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <div className="logo-wrapper">
            <img src={logo} alt="AroundU Logo" className="header-logo" />
          </div>
        </Link>
        
        <button className={`mobile-menu-btn ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li>
              <NavLink to="/" end onClick={() => setIsMenuOpen(false)}>Home</NavLink>
            </li>
            <li>
              <NavLink to="/providers" onClick={() => setIsMenuOpen(false)}>Services</NavLink>
            </li>
            <li>
              <NavLink to="/business" onClick={() => setIsMenuOpen(false)}>Business Portal</NavLink>
            </li>
            {isAdmin && (
              <li>
                <NavLink to="/admin" onClick={() => setIsMenuOpen(false)}>Admin Portal</NavLink>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;